import React from 'react'
import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import * as SocioService from 'services/socio.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  nombre: Yup.string().min(2).max(50).required(),
  telefono1: Yup.string().min(5).max(15).notRequired(),
  email1: Yup.string().min(3).max(150).email().notRequired(),
  comentario: Yup.string().min(5).max(500).notRequired()
})

const NuevoContactoModal = ({ handleClose, show, idSocio, onCreate }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      nombre: '',
      telefono1: '',
      email1: '',
      comentario: ''
    }),
    []
  )

  const submitHandler = async data => {
    SocioService.nuevoContactoxIdSocio(idSocio, data)
      .then(({ data }) => {
        __zariContext.snack('success', 'El contacto se ha creado.')
        onCreate({ _id: data._id })
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>NUEVO CONTACTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
              <FormGroups.Telefono1FormGroup iError={errors.telefono1} iTouched={touched.telefono1} fIsSubmitting={isSubmitting} />
              <FormGroups.Email1FormGroup iError={errors.email1} iTouched={touched.email1} fIsSubmitting={isSubmitting} />
              <FormGroups.ComentarioFormGroup iError={errors.comentario} iTouched={touched.comentario} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevoContactoModal)
